import React, { useEffect, useState, useCallback } from 'react';
import { useAuthContext } from '../contexts/AuthContext.js';
import { useNewChatContext } from '../contexts/NewChatContext.js';

const ConversationList = ({ setActiveComponent, setSelectedConversation, selectedUser, selectedConversation }) => {
    const [users, setUsers] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const [selectedDM, setSelectedDM] = useState(false)
    const { AuthData, updateAuthData, user, setUser } = useAuthContext();
    const [conversations, setConversations] = useState([]);
    const { newChatId, setNewChatId, setNewChatInput } = useNewChatContext();

    // useEffect(() => {
    //     // const token = sessionStorage.getItem("flaskAccessToken");
    //     // const token = AuthData?.flaskAccessToken || sessionStorage.getItem("flaskAccessToken");
    //     // console.log("UserList token:", token)
    //     // if (!token) return;
    //     if (!user?.user_id) return;

    //     fetch(`http://localhost:5000/get-conversations/${user.user_id}`
    //         //     , {
    //         //     headers: {
    //         //         Authorization: `Bearer ${token}`,
    //         //     }
    //         // }
    //     )
    //         .then(res => res.json())
    //         .then(data => {
    //             console.log("對話清單:", data);
    //             // setCurrentUser(data.current_user);
    //             // setUsers(data.users);
    //             // setUser(data.current_user)
    //             setConversations(data)
    //         })
    //         .catch(err => {
    //             console.error("取得對話失敗:", err);
    //         });
    // }, [user?.user_id]);

    const loadConversations = useCallback(() => {
        if (!user?.user_id) return;
        const ctrl = new AbortController();
        fetch(`http://localhost:5000/get-conversations/${user.user_id}`, { signal: ctrl.signal })
            .then(res => res.json())
            .then(data => {
                // 依需要可以把新建立的 id 排到最上面
                setConversations(data);
                console.log("對話清單:", data);
            })
            .catch(err => {
                if (err.name !== "AbortError") console.error("取得對話失敗:", err);
            });
        return () => ctrl.abort();
    }, [user?.user_id]);

    useEffect(() => {
        const abort = loadConversations();
        return () => abort?.();
    }, [loadConversations]);

    // ✅ 新對話建立後（newChatId 變動）自動重抓
    useEffect(() => {
        if (!newChatId) return;
        loadConversations();
    }, [newChatId, loadConversations]);

    // ✅ 當 newChatId 改變或 conversations 抓到資料時，找出那一筆並選取 + 捲動
    useEffect(() => {
        if (!newChatId || conversations.length === 0) return;
        const found = conversations.find(c => String(c.id) === String(newChatId));
        if (found) {
            setSelectedConversation(found);
            // 可選：自動捲動到該項
            const el = document.querySelector(`[data-conv-id="${found.id}"]`);
            el?.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
    }, [newChatId, conversations, setSelectedConversation]);


    const handleItClick = () => {
        setSelectedDM(!selectedDM);
    }

    const handleConversationClick = (conversation) => {
        // ✅ 先清掉 NewChat 的上下文，避免殘留
        setNewChatId(null);
        setNewChatInput(null);

        setSelectedConversation(conversation)
        setActiveComponent('ConversationWrapper')
    }

    useEffect(() => {
        console.log("selectedUser:", selectedUser)
    }, [selectedUser])

    // useEffect(() => {
    //     console.log("selectedDM:", selectedDM)
    // }, [selectedDM])
    return (
        <>
            <div className="menu-item" onClick={() => handleItClick()}>
                <img
                    src="./arrow02.png"
                    className={`arrow ${selectedDM ? "rotated" : ""}`}
                    alt="arrow"
                // onClick={handleClick}
                />
                <img src='./history.png' style={{ width: "18%" }}></img>
                <div>Chat History</div>
            </div>
            <div className='item-option-container'>
                <>
                    {selectedDM &&
                        conversations
                            .map((conversation) => {
                                const isSelected = selectedConversation?.id === conversation.id; // ✅ 用 id 比對
                                return (
                                    <div
                                        key={conversation.id}
                                        data-conv-id={conversation.id}                      // ✅ 供 scrollIntoView 查找
                                        className={`item-option ${isSelected ? "selected-option" : ""}`}
                                        onClick={() => handleConversationClick(conversation)}
                                    >
                                        {conversation.title}
                                    </div>
                                );
                                //     (
                                //     <div 
                                //     className={`item-option ${selectedConversation === conversation ? "selected-option" : ""}`}
                                //         onClick={() => handleConversationClick(conversation)} key={conversation.id}>
                                //         {conversation.title}
                                //     </div>
                                // )
                            })}
                    {/* {selectedDM && users && users
                        .filter((user) => user.user_id !== currentUser.user_id)
                        .map((user) => (
                            <li onClick={() => handleUserClick(user)} key={user.user_id}>
                                {user.user_name || user.user_email}
                            </li>
                        ))}

                    {selectedDM && users.users.map((user) => (
                        <li onClick={() => handleUserClick(user)}
                            key={user.user_id}>
                            {user.user_name || user.user_email}
                        </li>
                    ))} */}
                </>
            </div>
        </>
    );
};

export default ConversationList;
